module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Briefcase_16"],"path":[{"$":{"d":"M10,8h5v5H1V8H6V9h4Zm5-4V7H1V4H5V2h6V4ZM6,4h4V3H6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Briefcase_16.svg
// module id = 3cF0
// module chunks = 1